module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBvcGFjaXR5PSIuMSI+CiAgICA8cGF0aCBmaWxsPSJyZ2IoMjMyLDE1OSw1MCkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDBoMjBjNS41MTkxNTAyNCAwIDEwIDQuNDgwODQ5NzYgMTAgMTB2MjBjMCA1LjUxOTE1MDI0LTQuNDgwODQ5NzYgMTAtMTAgMTBIMTBDNC40ODA4NDk3NiA0MCAwIDM1LjUxOTE1MDI0IDAgMzBWMTBDMCA0LjQ4MDg0OTc2IDQuNDgwODQ5NzYgMCAxMCAweiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/user-attributes.svg
// module id = 1106
// module chunks = 32